import React, { Component } from "react";
//styles, images
import "../../../styles/TournamentPage.css";
import globe from "../../../images/games/globe.png";
import region from "../../../images/games/region.png";
import { RiFacebookFill, RiWhatsappFill } from "react-icons/ri";
import { AiFillInstagram } from "react-icons/ai";
import { FaTelegramPlane, FaTwitter } from "react-icons/fa";
import { Carousel } from "react-bootstrap";
import SocialMediaIcons from "../../common/SocialMediaIcons";

export default class TournamentFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tournamentDetails: this.props.tournamentDetails,
      tier1: this.props.tournamentDetails?.sponsorDetails?.filter(
        sponsor => sponsor.type === "Powered By" || sponsor.type === "Sponsored By"
      ),
      tier2: this.props.tournamentDetails?.sponsorDetails?.filter(
        sponsor => sponsor.type === "Co-Powered By" || sponsor.type === "Co-sponsored By"
      ),
      tier3: this.props.tournamentDetails?.sponsorDetails?.filter(
        sponsor => sponsor.type === "Associate Sponsor" || sponsor.type === "Streaming Partner"
      ),
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {
    this.setState({
      tournamentDetails: newProps.tournamentDetails,
      tier1: newProps.tournamentDetails?.sponsorDetails?.filter(
        sponsor => sponsor.type === "Powered By" || sponsor.type === "Sponsored By"
      ),
      tier2: newProps.tournamentDetails?.sponsorDetails?.filter(
        sponsor => sponsor.type === "Co-Powered By" || sponsor.type === "Co-sponsored By"
      ),
      tier3: newProps.tournamentDetails?.sponsorDetails?.filter(
        sponsor => sponsor.type === "Associate Sponsor" || sponsor.type === "Streaming Partner"
      ),
    });
  }

  htmlToElements = html => {
    var template = document.createElement("template");
    template.innerHTML = html;
    return template.content.childNodes;
  };

  getSocialMediaIcons = () => {
    const socialMediaPlatforms = ["facebook", "instagram", "telegram", "twitter", "whatsapp"];
    // const socialMediaIcons = [RiFacebookFill,AiFillInstagram,FaTelegramPlane,FaTwitter,RiWhatsappFill];
    const socialMediaIcons = [
      "RiFacebookFill",
      "AiFillInstagram",
      "FaTelegramPlane",
      "FaTwitter",
      "RiWhatsappFill",
    ];

    var arr = socialMediaPlatforms.map((platform, i) => {
      const temp = "<" + socialMediaIcons[i] + ' className="btn-size-20 text-dark"/>';
      return React.cloneElement(
        <div
          className="icon-container"
          style={{
            display: `${this.state.microWebSiteData.contactDetails[platform] ? "content" : "none"}`,
            backgroundColor: "#ffb800",
          }}
        >
          <a href={this.state.microWebSiteData.contactDetails[platform]}>
            {this.htmlToElements(temp)}
          </a>
        </div>
      );
    });
    return arr;
  };

  getTierSponsors = sponsors => {
    if (sponsors.length > 0) {
      return (
        <Carousel>
          {sponsors.map((sponsor, index) => {
            if (!(sponsor.ban || sponsor.block)) {
              return (
                <Carousel.Item key={index}>
                  <div className="d-flex flex-column">
                    <h1 className="fs-16 fw-600 text-warning text-center my-2 text-truncate">
                      {sponsor.type}
                    </h1>
                    <img
                      src={sponsor.logo?.url}
                      alt=""
                      className="border-2 border-white sponsor-logo-cover"
                    />
                    <h1 className="fs-14 fw-600 text-white text-center my-1">{sponsor.name}</h1>
                  </div>
                </Carousel.Item>
              );
            }
          })}
        </Carousel>
      );
    }
  };

  render() {
    const { tournamentDetails } = this.state;
    // Filter out Discord and WhatsApp from socialMediaDetails
    const filteredSocialMediaDetails = {};
    if (tournamentDetails?.organizationDetails?.socialMediaDetails) {
      for (const platform in tournamentDetails.organizationDetails.socialMediaDetails) {
        if (platform !== "discord" && platform !== "whatsapp") {
          filteredSocialMediaDetails[platform] =
            tournamentDetails.organizationDetails.socialMediaDetails[platform];
        }
      }
    }

    return (
      <section className="page-footer registration-user-footer p-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-12 d-flex align-items-start mt-3">
              <div>
                <img src={globe} alt="globe" style={{ height: "20px", width: "20px" }} />
              </div>
              <div className="ms-2">
                <h1 className="fs-20 fw-700 text-white">Time Zone</h1>
                <p className="fs-12 fw-700 text-white-50">
                  {Intl.DateTimeFormat().resolvedOptions().timeZone}
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-12 d-flex align-items-start mt-3">
              <div>
                <img src={region} alt="region" style={{ height: "18px", width: "18px" }} />
              </div>
              <div className="ms-2">
                <h1 className="fs-20 fw-700 text-white">Region</h1>
                <p className="fs-12 fw-700 text-white-50">{tournamentDetails?.region}</p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="tier-1">
                {this.state.tier1 ? this.getTierSponsors(this.state.tier1) : null}
              </div>
            </div>
            <div className="col-6 col-lg-3">
              <div className="tier-2">
                {this.state.tier2 ? this.getTierSponsors(this.state.tier2) : null}
              </div>
            </div>
            <div className="col-6 col-lg-3">
              <div className="tier-3">
                {this.state.tier3 ? this.getTierSponsors(this.state.tier3) : null}
              </div>
            </div>
          </div>

          <div className="d-flex flex-column my-3">
            {/* Organization Logo */}
            {this.state.tournamentDetails?.organizationDetails?.logo?.url && (
              <img
                src={this.state.tournamentDetails?.organizationDetails?.logo?.url}
                alt="logo"
                className="mx-auto rounded-15"
                style={{ height: "100px" }}
              />
            )}
            {/* Social Media Details */}
            <SocialMediaIcons
              socialMediaData={filteredSocialMediaDetails}
              backgroundColor="#ffb800"
              textColor="#000"
              showOnlyAvailable={true}
            />
          </div>
        </div>
      </section>
    );
  }
}
